import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import TrialsPage from "./pages/TrialsPage";
import CreditScorePage from "./pages/CreditScorePage";
import BillAlertsPage from "./pages/BillAlertsPage";
import WatchdogPage from "./pages/WatchdogPage";
import OnboardingSurvey from "./pages/OnboardingSurvey";
import "./styles/LandingPage.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/trials" element={<TrialsPage />} />
          <Route path="/credit-score" element={<CreditScorePage />} />
          <Route path="/bill-alerts" element={<BillAlertsPage />} />
          <Route path="/watchdog" element={<WatchdogPage />} />
          <Route path="/survey" element={<OnboardingSurvey />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
